var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container container_40 verification__approved-banner banner"
    },
    [
      _c("md-icon", { staticClass: "md-size-3x" }, [_vm._v("check")]),
      _vm._v(" "),
      _c("div", [
        _c("div", {
          staticClass: "banner__title text_x_large",
          domProps: {
            innerHTML: _vm._s(
              _vm.i18n.kyc_approved_title({
                account_type:
                  _vm.userType === _vm.userTypes.syndicate
                    ? _vm.i18n.kyc_corporate()
                    : _vm.i18n.kyc_general()
              })
            )
          }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "banner__description text_large" }, [
          _vm._v(_vm._s(_vm.i18n.kyc_approved_msg()))
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-wrap margin-top" },
        [
          _c(
            "md-button",
            {
              staticClass: "btn md-primary",
              on: {
                click: function($event) {
                  return _vm.updateKYC()
                }
              }
            },
            [_vm._v(_vm._s(_vm.i18n.kyc_update()))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67154309", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67154309","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/verification/make/Verification.ApprovedBanner.vue
// module id = 8Kzy
// module chunks = 1